import { jsx as r } from "react/jsx-runtime";
import { c as a } from "../../../clsx-OuTLNxxd.js";
const d = "_divider_1lvcv_1", s = {
  divider: d,
  "small-space": "_small-space_1lvcv_5"
};
function t({ className: i, smallSpace: c, ...e }) {
  const l = a(s.divider, c && s["small-space"], i);
  return /* @__PURE__ */ r("div", { className: l, ...e });
}
export {
  t as Divider
};
